/**
 * The words on a teacher's payment link (D-716).
 *
 * `asked`: *"could we make it just be a vanity link like "Venmo" or something
 * instead of the full url"*. A Venmo share link is ~80 characters of query
 * string, and it wrapped across the line on a family's schedule.
 *
 * The services a teacher is likely to paste are named; anything else shows its
 * site (`square.link`), which still says where the tap goes. A string that is not
 * a web address falls back to plain words rather than printing itself.
 */
const NAMED: [host: string, name: string][] = [
  ['venmo.com', 'Venmo'],
  ['paypal.me', 'PayPal'],
  ['paypal.com', 'PayPal'],
  ['cash.app', 'Cash App'],
  ['zellepay.com', 'Zelle'],
]

export function payLinkLabel(link: string): string {
  let host: string
  try {
    host = new URL(link).hostname.toLowerCase()
  } catch {
    return 'Payment link'
  }
  if (!host) return 'Payment link'

  const named = NAMED.find(([h]) => host === h || host.endsWith(`.${h}`))
  return named ? named[1] : host.replace(/^www\./, '')
}
